import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { CloseCode, createClient } from 'graphql-ws';

// non-fatal WebSocket connection close events will cause the
// client to automatically reconnect. the retries are silent, meaning
// that the client will not error out unless the retry attempts have been
// exceeded or the close event was fatal (read more about the fatal
// close events in the documentation). additionally, all active subscriptions
// will automatically resubscribe upon successful reconnect. this behaviour
// can be leveraged to implement a secure and sound way of authentication;
// handling server-side validation, expiry indication and timely token refreshes

// indicates that the server closed the connection because of
// an auth problem. it indicates that the token should refresh
let shouldRefreshToken = false;
// the socket close timeout due to token expiry
// const tokenExpiryTimeout: number | null = null;

export const wsLink = ({ token }: { token: string }): GraphQLWsLink =>
  new GraphQLWsLink(
    createClient({
      url: `${process.env.REACT_APP_API_URL?.replace('https:', 'wss:')?.replace('http:', 'ws:')}/subscriptions`,
      connectionParams: async () => {
        const currentToken = token;
        if (shouldRefreshToken) {
          // refresh the token because it is no longer valid
          // TODO: Refresh auth token in WebSocket link
          // currentToken = await refreshCurrentToken();
          // and reset the flag to avoid refreshing too many times
          shouldRefreshToken = false;
        }
        return { authToken: currentToken };
      },
      // TODO: Refresh auth token in WebSocket link
      on: {
        //   connected: (untypedSocket) => {
        //     const socket = untypedSocket as WebSocket; // Their docs state it's `WebSocket` but they can't type it due to DOM typings being unusable in Node.js.
        //     // clear timeout on every connect for debouncing the expiry
        //     clearTimeout(tokenExpiryTimeout);

        //     // set a token expiry timeout for closing the socket
        //     // with an `4403: Forbidden` close event indicating
        //     // that the token expired. the `closed` event listner below
        //     // will set the token refresh flag to true
        //     tokenExpiryTimeout = setTimeout(() => {
        //       if (socket.readyState === WebSocket.OPEN) socket.close(CloseCode.Forbidden, 'Forbidden');
        //     }, getCurrentTokenExpiresIn());
        //   },
        closed: (event) => {
          // if closed with the `4403: Forbidden` close event
          // the client or the server is communicating that the token
          // is no longer valid and should be therefore refreshed
          const typedEvent = event as CloseEvent; // Their docs state it's `CloseEvent` but they can't type it due to DOM typings being unusable in Node.js.
          if (typedEvent.code === CloseCode.Forbidden) shouldRefreshToken = true;
        },
      },
    })
  );
